import {
  Button,
  Loading,
  MessageBox,
  TextBase,
  TextCaption,
} from '@carboncopyco/ui';
import { useEffect, useState } from 'react';
import { settings } from '../../../../../settings';
import { GB_IN_BYTES } from '../../../../shared/constants/constants';

export const PersistentStorage = () => {
  const [directorySize, setDirectorySize] = useState<number>(0);
  const [totalFreeDiskSpace, setTotalFreeDiskSpace] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const size = await window.dsDesktop.dsCache.calculateCacheSize();
      const diskSpace = await window.dsDesktop.dsCache.totalFreeDiskSpace();
      setDirectorySize(size);
      setTotalFreeDiskSpace(diskSpace);
    })();
  }, []);

  return (
    <div className="flex flex-col">
      <div className="flex w-full items-center justify-between">
        <div>
          <TextBase
            label="Clear cache to free up disk space"
            color="text-ds-natural-600"
          />
        </div>
        <div className="-mr-7">
          {isLoading ? (
            <Loading color="text-ds-primary" />
          ) : (
            <Button
              secondary
              xSmall
              onClick={async () => {
                setIsLoading(true);
                await window.dsDesktop.dsCache.clearCache();
                const size =
                  await window.dsDesktop.dsCache.calculateCacheSize();
                setDirectorySize(size);
                setTimeout(() => {
                  setIsLoading(false);
                }, 500);
              }}
              label="Clear Cache"
            />
          )}
        </div>
      </div>
      <div className="mt-4 natural-200 -mr-7">
        <MessageBox
          border
          borderColor="border-ds-natural-200"
          label={
            <div className=" pl-1.5 flex flex-row gap-2.5">
              <TextCaption
                color="text-ds-natural-600"
                label="Disk Used: "
                fontWeight="font-ds-bold"
              />

              <TextCaption
                color="text-ds-natural-600"
                label={`Used: ${
                  Math.round(
                    (directorySize / GB_IN_BYTES + Number.EPSILON) * 100
                  ) / 100
                } GB`}
              />
              <TextCaption
                color="text-ds-natural-600"
                label={`|\xa0\xa0\xa0Available: ${Math.ceil(totalFreeDiskSpace / GB_IN_BYTES)} GB`}
              />
              <TextCaption
                color="text-ds-natural-600"
                label={`|\xa0\xa0\xa0Minimum required ${settings.BOOST_DISK_SPACE_LIMIT}GB`}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};
